import styles from '../../../components/OverviewV2/OverviewV2.module.scss'
import React, { useEffect, useRef, useState } from 'react'
import { Tooltip } from '../../tooltips/default'

export const OverflowText = ({ text = '', maxDisplayWidth = '100%' }: { text?: string; maxDisplayWidth?: string }) => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const [isClipped, setIsClipped] = useState(false)

  useEffect(() => {
    const node = textRef.current
    if (!node) return

    const checkClipping = () => {
      requestAnimationFrame(() => {
        setIsClipped(node.scrollWidth > node.clientWidth)
      })
    }

    checkClipping()

    window.addEventListener('resize', checkClipping)
    return () => {
      window.removeEventListener('resize', checkClipping)
    }
  }, [text, maxDisplayWidth])

  return (
    <div className={styles.overflowWrapper}>
      <Tooltip title={isClipped ? text : undefined} placement='bottomLeft'>
        <div ref={textRef} className={styles.textTruncate} style={{ maxWidth: maxDisplayWidth }}>
          {text}
        </div>
      </Tooltip>
    </div>
  )
}
